var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"align-center"},[_vm._v("Add illustration")]),_vm._v(" "),_c('create-form',{attrs:{"save":_vm.store}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }